import React, { useEffect, useState } from "react";
import "./ScrambleaWord.css";
import { FaChevronRight } from "react-icons/fa";
import useUserInfo from "../../../Hooks/useUserInfo";
import ScrambleaWordPlay from "./ScrambleaWordPlay.js";
import Menu from "../../menu/menu";
import Tv from "../../Tv/Tv";
import cancelIcon from "../../../assets/Task/cancelicon.svg";
import { useAudio } from "../../../Providers/AudioProvider";
import { logPageView } from "../../../components/analytics";

const ScrambleaWord = () => {
  const { userDetails, updateUserInfo } = useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;
  const [scrambleProgress, setScrambleProgress] = useState([]);
  const startDate = new Date("2025-01-09");
  const totalDays = 84; // Total days from startDate to endDate
  const daysInPhase = 7; // Number of days per phase
  const totalScramblesPerDay = 5;
  const playClick = useAudio();

  // Function to simulate the current day based on the start date
  const calculateSimulatedDay = () => {
    const today = new Date(userDetails?.userDetails?.lastLogin); // This will be used to simulate the current day
    const diffTime = Math.abs(today - startDate);
    const simulatedDay = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return simulatedDay > 0 ? simulatedDay : 1; // Ensure that Day 1 is correctly set
  };
  const simulatedDay = calculateSimulatedDay();
  const currentPhase = Math.ceil(simulatedDay / daysInPhase);

  useEffect(() => {
    logPageView("Scrambleword", "Scramble Word Page");
  }, []);

  useEffect(() => {
    if (simulatedDay > totalDays) {
      setScrambleProgress([]);
    } else {
      const progress = Array.from({ length: daysInPhase }, (_, i) => {
        const day = (currentPhase - 1) * daysInPhase + i + 1;
        const completedIndex =
          parseInt(localStorage.getItem(`scrambleIndex_day${day}_${userId}`)) ||
          0;
        const scramblesRemaining = totalScramblesPerDay - completedIndex;
        if (day <= simulatedDay && scramblesRemaining > 0) {
          return ` Play Game ${scramblesRemaining}/5 `;
        } else if (completedIndex >= totalScramblesPerDay) {
          return "Completed";
        } else {
          return "Locked";
        }
      });
      setScrambleProgress(progress);
    }
  }, [currentPhase, simulatedDay]);

  const goToThePage = (component, name, isDisabled) => {
    if (isDisabled) return; // Prevent navigation if the day is disabled
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: name,
      lastComponent: userDetails.currentComponent,
      lastComponentText: userDetails.currentComponentText,
      isMenu: !userDetails.isMenu,
    }));
    playClick();
  };

  const toogleMenu = () => {
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: Menu,
      currentComponentText: "MenuPage",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
    playClick();
  };

  return (
    <div className="quiz-task menupointer">
      <img
        onClick={() => {
          toogleMenu(Tv, "Tv");
        }}
        src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
        className="cancel-imgpoints"
        style={{ cursor: "pointer" }}
      />
      {simulatedDay > totalDays ? (
        <>
            <div className="spinning-animation-sv"></div>
            <div  style={{padding:"30px"}}>
          <h1 className=" txt-color">Congrats!
 </h1>
          <p className="completion-message"> You’ve successfully completed the Word Scramble.
          Stay tuned for more exciting games!</p>
        </div></>
      
      ) : (
        <>
          <h1 className="welcome-text">Word Scramble </h1>
          <h2 className="phase-text">Phase {currentPhase}</h2>
          <div className="days-container">
            {Array.from({ length: daysInPhase }, (_, i) => {
              const day = (currentPhase - 1) * daysInPhase + i + 1;
              const isCompleted = scrambleProgress[i] === "Completed";
              const isDisabled = scrambleProgress[i] === "Locked";
              return (
                <div key={i} className="day-box">
                  <div className="day-label">Day {i + 1}</div>
                  <div
                    onClick={() => {
                      goToThePage(
                        () => <ScrambleaWordPlay day={day} />,
                        "ScrambleaWordPlay",
                        isDisabled || isCompleted
                      );
                    }}
                    className="play-status"
                    style={{
                      cursor:
                        isDisabled || isCompleted ? "not-allowed" : "pointer",
                      color: isDisabled
                        ? "grey"
                        : isCompleted
                        ? "darkgrey"
                        : "#ccc",
                    }}
                  >
                    {scrambleProgress[i]} <FaChevronRight />
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
export default ScrambleaWord;
